import React, { useRef } from 'react'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { ErrorView } from '../../../views/error/ErrorView'
import { IllustrationChoices } from '../../common/Illustration'
import { Modal } from '../../common/Modal'
import { ModalBody } from '../../common/Modal/ModalBody'
import { ModalHeader } from '../../common/Modal/ModalHeader'
import { ConversationsList } from '../Conversations'

interface PublicGroupsModalProps {
  show: boolean
  close: () => void
  onItemSelect: () => void
}

export const PublicGroupsModal = ({
  show,
  close,
  onItemSelect,
}: PublicGroupsModalProps): JSX.Element => {
  const { translate } = useAppTranslation()
  const ref = useRef(null)
  return (
    <Modal ref={ref} show={show}>
      {{
        header: (
          <ModalHeader onClose={close}>
            {translate('publicGroups.header')}
          </ModalHeader>
        ),
        body: (
          <ModalBody className="max-h-96 overflow-y-auto">
            <div className="flex flex-col">
              <ConversationsList
                type="interests"
                state="joinable"
                rootRef={ref}
                rowClassName="border-b border-neutral-80 p-4 hover:bg-neutral-96"
                onRowClick={onItemSelect}
                emptyState={
                  <ErrorView
                    title={translate('publicGroups.errorViews.noGroups.title')}
                    subtitle={translate(
                      'publicGroups.errorViews.noGroups.subtitle'
                    )}
                    illustration={IllustrationChoices.EMPTY}
                    illustrationHeight={250}
                    illustrationWidth={187}
                  />
                }
              />
            </div>
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
